exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dictionariesModal .v-messages{display:none}#dictionariesModal .v--modal-box.v--modal{min-height:280px!important;min-width:450px!important}#dictionariesModal .v-select__selections,.v-list__tile__title{font-size:12px}.list__dict{height:calc(100% - 50px)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dd5fcac","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/dictionaries/Dictionaries.vue
// module id = 1913
// module chunks = 0